import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

import { SortableData } from './types';

type DndKitSortableItemProps<T> = {
  id: UniqueIdentifier;
  isOver?: boolean;
} & SortableData<T>;

export function DndKitSortableItem<T>({
  id,
  children,
  itemType,
  isDroppable,
  isOver,
  onSort,
  onDrop,
  props,
}: DndKitSortableItemProps<T>) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    data: {
      itemType,
      onSort,
      onDrop,
      isDroppable,
      children,
      props,
    } satisfies SortableData<T>,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      className={classNames('relative w-full', isDragging && 'opacity-0')}
      {...attributes}
      {...listeners}
    >
      {/* Droppable border */}
      <div
        className={classNames(
          'absolute inset-0 box-border shadow-[inset_0_0_0_2px] shadow-primary',
          'transition-opacity ease duration-100',
          // Hide border using opacity so transition is smooth
          isDroppable && isOver ? 'opacity-100' : 'opacity-0'
        )}
      />
      {/* Content */}
      {children}
    </div>
  );
}
